import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom'; // Added for button navigation
import DonateBtn from './DonateBtn';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative h-[750px] flex items-center justify-center text-white overflow-hidden">
      {/* Background Image with Hover Zoom Effect */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-[2000ms] hover:scale-110"
        style={{ backgroundImage: "url('/images/backg.png')" }}
      ></div>

      {/* Cinematic Overlay: Gradient from dark to blue-tint */}
      <div className="absolute inset-0 bg-gradient-to-b md:bg-gradient-to-r from-black/90 via-black/60 to-gh-blue/30 z-10"></div>

      {/* Hero Content */}
      <div className="relative z-20 max-w-6xl mx-auto text-center px-6">
        <span className="inline-block px-4 py-1 mb-8 border border-gh-orange text-gh-orange rounded-full text-xs font-black tracking-[0.3em] uppercase animate-pulse">
          Restoring Childhoods • Rebuilding Lives
        </span>
        
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black mb-8 leading-[1.1] drop-shadow-2xl">
          Hope for the <br />
          <span className="text-gh-orange italic">Forgotten</span>
        </h1>
        
        <p className="text-lg md:text-2xl mb-12 text-gray-200 max-w-3xl mx-auto leading-relaxed font-light italic">
          We are a sanctuary for orphans, homeless, and abandoned children in Mityana. 
          Providing a loving home, quality education, and life-changing support to 
          turn vulnerability into a future of purpose.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
          {/* Linked to Sponsorship Page */}
          <button 
            onClick={() => navigate('/sponsorship')}
            className="w-full sm:w-auto bg-gh-orange text-white px-10 py-5 rounded-full text-lg font-bold flex items-center justify-center gap-3 hover:bg-orange-600 transition-all shadow-xl hover:-translate-y-1 active:scale-95"
          >
            SPONSOR A CHILD <ArrowRight size={22} />
          </button>
          
          <div className="w-full sm:w-auto group">
             <DonateBtn className="w-full sm:w-auto px-10 py-5 !bg-white/10 backdrop-blur-md border border-white/30 text-white hover:!bg-white hover:text-gh-blue rounded-full text-lg transition-all shadow-lg active:scale-95" />
          </div>
        </div>
      </div>
    </section>
  );
}